export const PILLARS = [
  {
    num: "01",
    name: "Love",
    role: "The Source",
    text: "The foundational orientation that gives meaning and direction to all virtues — an enduring commitment to seek the genuine good of others, honoring truth, justice, wisdom, and dignity.",
  },
  {
    num: "02",
    name: "Virtues",
    role: "The Genes",
    text: "The specific qualities through which love becomes visible — compassion, forgiveness, justice, patience — interconnected expressions that gain greater meaning when practiced together.",
  },
  {
    num: "03",
    name: "Character",
    role: "The Expression",
    text: "Virtues practiced consistently become habits, and habits shape character — the visible manifestation of love in everyday choices, representing who we are even when unobserved.",
  },
  {
    num: "04",
    name: "Relationships",
    role: "The Ecosystem",
    text: "Character develops and is tested within families, friendships, workplaces, and communities. A healthy ecosystem nurtures flourishing; an unhealthy one can hinder it.",
  },
  {
    num: "05",
    name: "Human Flourishing",
    role: "The Outcome",
    text: "The ongoing development of individuals and communities marked by purpose, dignity, wisdom, compassion, integrity, and resilience — even amidst hardship.",
  },
];

export const QUOTES = [
  "What if love is not merely something we feel, but a living system we can understand, cultivate, and become?",
  "Love is not one virtue among many. It is the shelter under which every virtue finds its purpose.",
  "Virtues are not inherited. They are practiced — day by day, choice by choice — until they become who we are.",
  "Growth begins the moment we are willing to look at ourselves without flinching and without contempt.",
  "Love was never meant to stop with one life. Its nature is to multiply.",
  "The highest question of a life is not what I achieved, but who flourished because I lived.",
];

export const MARQUEE_WORDS = [
  "Love", "Virtues", "Character", "Relationships", "Flourishing",
];

export const TESTIMONIALS = [
  {
    quote:
      "You believed in this work before I had the courage to write it. You are the reason my heart still believes in love.",
    name: "A Letter to My Husband",
    role: "From the dedication",
  },
  {
    quote:
      "A framework that finally gives us a shared language for love — not as sentiment, but as a way of becoming. It changed how I lead and how I parent.",
    name: "Early Reader",
    role: "Educator & Coach",
  },
  {
    quote:
      "Whether through the surgeries, the sleepless nights, or the long silences — this is a book born of lived truth. It reads like an embrace.",
    name: "Advance Review",
    role: "Nonprofit Founder",
  },
  {
    quote:
      "The five pillars gave our team a way to talk about character and care at work without it feeling soft. It's rigorous and deeply human.",
    name: "Workplace Reader",
    role: "People Leader, Fortune 500",
  },
];

export const FAQS = [
  {
    q: "What is The Love Genome™?",
    a: "A proprietary educational and virtue-based framework that presents love as the organizing source from which virtues are cultivated, character is formed, relationships are strengthened, and human flourishing is encouraged.",
  },
  {
    q: "Is it a biological or scientific theory?",
    a: "No. The word “genome” is used metaphorically. The Love Genome™ is an educational and philosophical framework, not a scientific or psychological claim.",
  },
  {
    q: "How is love defined in this framework?",
    a: "Love is understood as more than emotion — it is an enduring commitment to seek the genuine good of others, honoring truth, justice, wisdom, and dignity.",
  },
  {
    q: "What are the five pillars?",
    a: "Love as the Source, Virtues as the Genes, Character as the Expression, Relationships as the Ecosystem, and Human Flourishing as the Outcome.",
  },
  {
    q: "Can the framework help with difficult conversations?",
    a: "Yes. It shows how hard conversations can be acts of love when they hold truth and kindness together — through preparation, invitation, speaking, listening, and agreeing on next steps.",
  },
  {
    q: "Who is this book for?",
    a: "Anyone who has asked what it truly means to love — individuals seeking growth, families, educators, coaches, and leaders who want a shared language for character and care.",
  },
];

export const MEDIA = [
  { label: "Podcast", title: "The Love Genome™ on Purpose & Practice", meta: "Interview · Coming Soon" },
  { label: "Feature", title: "Reframing Love as a System for Flourishing", meta: "Editorial · Coming Soon" },
  { label: "Keynote", title: "Love as Leadership in the Modern Workplace", meta: "Talk · Coming Soon" },
];
